module.exports = "/assets/data/139bac8ae8324ef742ba7481ac36a368-G66.data.json";